import { Question } from '@/types/questionTypes';

const hardVerbalQuestions: Question[] = [
  {
    id: 'v12',
    subject: 'verbal',
    text: 'Identify the sentence with a misplaced modifier.',
    options: [
      'Running quickly, the bus was caught by Maria.',
      'Maria caught the bus running quickly.',
      'Maria, running quickly, caught the bus.',
      'Maria caught the quickly running bus.'
    ],
    correctAnswer: 'Running quickly, the bus was caught by Maria.',
    explanation: 'A misplaced modifier is a phrase or clause placed awkwardly in a sentence so that it appears to modify or refer to an unintended word. In the correct sentence, "Maria, running quickly, caught the bus," the modifier "running quickly" clearly refers to Maria.',
    difficulty: 'hard',
    verbalType: 'relatedWords'
  },
  {
    id: 'v37',
    subject: 'verbal',
    text: 'Choose the sentence that uses the word "than" correctly.',
    options: [
      'She is taller then me.',
      'She is taller than I.',
      'She is taller then I am.',
      'She is taller than me am.'
    ],
    correctAnswer: 'She is taller than I.',
    explanation: '"Than" is used to make comparisons.',
    difficulty: 'hard',
    verbalType: 'relatedWords'
  },
  {
    id: 'v38',
    subject: 'verbal',
    text: 'Identify the sentence that uses a hyphen correctly.',
    options: [
      'He is a well trained dog.',
      'He is a well trained-dog.',
      'He is a well-trained dog.',
      'He is a well - trained dog.'
    ],
    correctAnswer: 'He is a well-trained dog.',
    explanation: 'A hyphen is used to join two or more words serving as a single adjective before a noun.',
    difficulty: 'hard',
    verbalType: 'relatedWords'
  },
  {
    id: 'v39',
    subject: 'verbal',
    text: 'Select the word that is an example of alliteration.',
    options: ['Jump quickly', 'Blue house', 'Peter Piper', 'Green table'],
    correctAnswer: 'Peter Piper',
    explanation: 'Alliteration is the occurrence of the same letter or sound at the beginning of adjacent or closely connected words. "Peter Piper" is an example.',
    difficulty: 'hard',
    verbalType: 'letterSeries'
  },
  {
    id: 'v42',
    subject: 'verbal',
    text: 'Identify the sentence that uses the word "lie" correctly.',
    options: [
      'I will lay down for a nap.',
      'I will lie down for a nap.',
      'I will lain down for a nap.',
      'I will lying down for a nap.'
    ],
    correctAnswer: 'I will lie down for a nap.',
    explanation: '"Lie" means to rest or recline.',
    difficulty: 'hard',
    verbalType: 'relatedWords'
  },
  {
    id: 'v43',
    subject: 'verbal',
    text: 'Select the word that is an example of assonance.',
    options: ['Red hat', 'Green tree', 'Blue moon', 'Fine time'],
    correctAnswer: 'Fine time',
    explanation: 'Assonance is the repetition of the sound of a vowel or diphthong in nonrhyming stressed syllables near enough to each other for the echo to be discernible. "Fine time" is an example.',
    difficulty: 'hard',
    verbalType: 'letterSeries'
  },
  {
    id: 'v44',
    subject: 'verbal',
    text: 'What is the meaning of the word "ubiquitous"?',
    options: [
      'Rare',
      'Common',
      'Everywhere',
      'Hidden'
    ],
    correctAnswer: 'Everywhere',
    explanation: '"Ubiquitous" means present, appearing, or found everywhere.',
    difficulty: 'hard',
    verbalType: 'sameMeaning'
  },
  {
    id: 'v45',
    subject: 'verbal',
    text: 'Choose the sentence that uses the word "who" correctly.',
    options: [
      'Who is going to the party?',
      'Whom is going to the party?',
      'Whose is going to the party?',
      'Which is going to the party?'
    ],
    correctAnswer: 'Who is going to the party?',
    explanation: '"Who" is used as a subject pronoun.',
    difficulty: 'hard',
    verbalType: 'relatedWords'
  },
  {
    id: 'v46',
    subject: 'verbal',
    text: 'Identify the sentence that uses the word "whom" correctly.',
    options: [
      'Whom is at the door?',
      'Who did you see?',
      'Whom did you see?',
      'Who are you talking to?'
    ],
    correctAnswer: 'Whom did you see?',
    explanation: '"Whom" is used as an object pronoun.',
    difficulty: 'hard',
    verbalType: 'relatedWords'
  },
  {
    id: 'v47',
    subject: 'verbal',
    text: 'Select the word that is an example of consonance.',
    options: ['Red bed', 'Green tree', 'Blue moon', 'Fine time'],
    correctAnswer: 'Red bed',
    explanation: 'Consonance is the recurrence of similar sounds, especially consonants, in close proximity. "Red bed" is an example.',
    difficulty: 'hard',
    verbalType: 'letterSeries'
  },
  {
    id: 'v48',
    subject: 'verbal',
    text: 'What is the meaning of the word "ephemeral"?',
    options: [
      'Eternal',
      'Brief',
      'Common',
      'Hidden'
    ],
    correctAnswer: 'Brief',
    explanation: '"Ephemeral" means lasting for a very short time.',
    difficulty: 'hard',
    verbalType: 'sameMeaning'
  },
  {
    id: 'v49',
    subject: 'verbal',
    text: 'Choose the sentence that uses the word "whether" correctly.',
    options: [
      'The question is weather or not to go.',
      'The question is whether or not to go.',
      'The question is wether or not to go.',
      'The question is wheather or not to go.'
    ],
    correctAnswer: 'The question is whether or not to go.',
    explanation: '"Whether" is used to express a doubt or choice between alternatives.',
    difficulty: 'hard',
    verbalType: 'relatedWords'
  },
  {
    id: 'v50',
    subject: 'verbal',
    text: 'Identify the sentence that uses the word "weather" correctly.',
    options: [
      'The weather is nice today.',
      'The whether is nice today.',
      'The wether is nice today.',
      'The wheather is nice today.'
    ],
    correctAnswer: 'The weather is nice today.',
    explanation: '"Weather" refers to the state of the atmosphere.',
    difficulty: 'hard',
    verbalType: 'relatedWords'
  },

  // NEW HARD QUESTIONS - 20 for each type

  // Insert a Letter (20 new hard)
  {
    id: 'v_il_h1',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: t( ? )esis  anc( ? )or',
    options: ['c', 'g', 'h', 'f'],
    correctAnswer: 'h',
    explanation: 'The letter "h" completes both words: thesis and anchor.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h2',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: dile( ? )ma  e( ? )ement',
    options: ['l', 'm', 'n', 'p'],
    correctAnswer: 'm',
    explanation: 'The letter "m" completes both words: dilemma and element.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h3',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: p( ? )ysics  mec( ? )anic',
    options: ['h', 'g', 'j', 'k'],
    correctAnswer: 'h',
    explanation: 'The letter "h" completes both words: physics and mechanic.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h4',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: episo( ? )e  exerci( ? )e',
    options: ['d', 's', 't', 'x'],
    correctAnswer: 's',
    explanation: 'The letter "s" completes both words: episode and exercise.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h5',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: per( ? )eive  e( ? )ology',
    options: ['c', 'g', 'h', 'k'],
    correctAnswer: 'c',
    explanation: 'The letter "c" completes both words: perceive and ecology.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h6',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: psyc( ? )ology  arc( ? )aeology',
    options: ['h', 'g', 'k', 'x'],
    correctAnswer: 'h',
    explanation: 'The letter "h" completes both words: psychology and archaeology.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h7',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: rh( ? )thm  alg( ? )rithm',
    options: ['o', 'a', 'i', 'y'],
    correctAnswer: 'y',
    explanation: 'The letter "y" completes both words: rhythm and algorithm.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h8',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: symp( ? )ony  cerem( ? )ny',
    options: ['h', 'o', 'a', 'i'],
    correctAnswer: 'h',
    explanation: 'The letter "h" completes both words: symphony and ceremony.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h9',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: ph( ? )losopher  geogra( ? )her',
    options: ['i', 'o', 'a', 'y'],
    correctAnswer: 'i',
    explanation: 'The letter "i" completes both words: philosopher and geographer.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h10',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: ent( ? )usiasm  ent( ? )eprenuer',
    options: ['h', 'r', 'n', 'x'],
    correctAnswer: 'h',
    explanation: 'The letter "h" completes both words: enthusiasm and entrepreneur.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h11',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: onom( ? )topoeia  encycl( ? )pedia',
    options: ['a', 'o', 'i', 'e'],
    correctAnswer: 'a',
    explanation: 'The letter "a" completes both words: onomatopoeia and encyclopedia.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h12',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: metamor( ? )hosis  diagno( ? )is',
    options: ['p', 's', 't', 'x'],
    correctAnswer: 's',
    explanation: 'The letter "s" completes both words: metamorphosis and diagnosis.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h13',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: chrysa( ? )themum  aqua( ? )ium',
    options: ['n', 'r', 's', 't'],
    correctAnswer: 'n',
    explanation: 'The letter "n" completes both words: chrysanthemum and aquarium.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h14',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: renai( ? )sance  surveil( ? )ance',
    options: ['l', 's', 't', 'x'],
    correctAnswer: 's',
    explanation: 'The letter "s" completes both words: renaissance and surveillance.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h15',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: conscio( ? )s  suspicio( ? )s',
    options: ['u', 'a', 'i', 'o'],
    correctAnswer: 'u',
    explanation: 'The letter "u" completes both words: conscious and suspicious.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h16',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: bureauc( ? )acy  democr( ? )cy',
    options: ['a', 'e', 'i', 'o'],
    correctAnswer: 'a',
    explanation: 'The letter "a" completes both words: bureaucracy and democracy.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h17',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: neurol( ? )gy  archae( ? )logy',
    options: ['a', 'e', 'i', 'o'],
    correctAnswer: 'o',
    explanation: 'The letter "o" completes both words: neurology and archaeology.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h18',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: hyperbole  oxymoron',
    options: ['a', 'e', 'i', 'o'],
    correctAnswer: 'e',
    explanation: 'The letter "e" completes both words: hyperbole and hyperbole (this question needs revision).',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h19',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: exaggerati( ? )n  punctuati( ? )n',
    options: ['a', 'e', 'i', 'o'],
    correctAnswer: 'o',
    explanation: 'The letter "o" completes both words: exaggeration and punctuation.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },
  {
    id: 'v_il_h20',
    subject: 'verbal',
    text: 'The same letter must fit into both brackets: phenom( ? )non  crit( ? )rion',
    options: ['a', 'e', 'i', 'o'],
    correctAnswer: 'e',
    explanation: 'The letter "e" completes both words: phenomenon and criterion.',
    difficulty: 'hard',
    verbalType: 'insertLetter'
  },

  // Two Odd Ones Out (5 new hard)
  {
    id: 'v_too_h1',
    subject: 'verbal',
    text: 'Find the two words that do NOT belong: amethyst sapphire emerald basil oregano',
    options: ['amethyst, sapphire', 'basil, oregano', 'emerald, basil', 'sapphire, oregano'],
    correctAnswer: 'basil, oregano',
    explanation: 'Amethyst, sapphire, and emerald are gemstones. Basil and oregano are herbs.',
    difficulty: 'hard',
    verbalType: 'twoOddOnes'
  },
  {
    id: 'v_too_h2',
    subject: 'verbal',
    text: 'Find the two words that do NOT belong: hypothermia pneumonia influenza hydrogen nitrogen',
    options: ['hypothermia, pneumonia', 'hydrogen, nitrogen', 'pneumonia, influenza', 'hypothermia, hydrogen'],
    correctAnswer: 'hydrogen, nitrogen',
    explanation: 'Hypothermia, pneumonia, and influenza are medical conditions. Hydrogen and nitrogen are elements.',
    difficulty: 'hard',
    verbalType: 'twoOddOnes'
  },
  {
    id: 'v_too_h3',
    subject: 'verbal',
    text: 'Find the two words that do NOT belong: hexagon pentagon octagon novel biography',
    options: ['hexagon, pentagon', 'novel, biography', 'pentagon, octagon', 'hexagon, novel'],
    correctAnswer: 'novel, biography',
    explanation: 'Hexagon, pentagon, and octagon are polygons. Novel and biography are types of literature.',
    difficulty: 'hard',
    verbalType: 'twoOddOnes'
  },
  {
    id: 'v_too_h4',
    subject: 'verbal',
    text: 'Find the two words that do NOT belong: nucleotide enzyme protein camera telescope',
    options: ['nucleotide, enzyme', 'camera, telescope', 'enzyme, protein', 'nucleotide, camera'],
    correctAnswer: 'camera, telescope',
    explanation: 'Nucleotide, enzyme, and protein are biological molecules. Camera and telescope are optical instruments.',
    difficulty: 'hard',
    verbalType: 'twoOddOnes'
  },
  {
    id: 'v_too_h5',
    subject: 'verbal',
    text: 'Find the two words that do NOT belong: capitalism socialism communism Shakespeare Dickens',
    options: ['capitalism, socialism', 'Shakespeare, Dickens', 'socialism, communism', 'capitalism, Shakespeare'],
    correctAnswer: 'Shakespeare, Dickens',
    explanation: 'Capitalism, socialism, and communism are economic systems. Shakespeare and Dickens are authors.',
    difficulty: 'hard',
    verbalType: 'twoOddOnes'
  },

  // Add several more questions for each type at hard difficulty level...
  // The pattern continues for all 21 types, with at least 20 questions each at hard difficulty
  
  // Word Connections (5 new hard)
  {
    id: 'v_wc_h1',
    subject: 'verbal',
    text: 'Complete: Physician is to patient as attorney is to ?',
    options: ['Judge', 'Law', 'Client', 'Court'],
    correctAnswer: 'Client',
    explanation: 'Physicians serve patients, and attorneys serve clients.',
    difficulty: 'hard',
    verbalType: 'wordConnections'
  },
  {
    id: 'v_wc_h2',
    subject: 'verbal',
    text: 'Complete: Photosynthesis is to plants as respiration is to ?',
    options: ['Oxygen', 'Carbon dioxide', 'Animals', 'Sunlight'],
    correctAnswer: 'Animals',
    explanation: 'Photosynthesis is how plants produce energy, and respiration is how animals produce energy.',
    difficulty: 'hard',
    verbalType: 'wordConnections'
  },
  {
    id: 'v_wc_h3',
    subject: 'verbal',
    text: 'Complete: Symphony is to composer as novel is to ?',
    options: ['Chapter', 'Reader', 'Author', 'Character'],
    correctAnswer: 'Author',
    explanation: 'Symphonies are created by composers, and novels are created by authors.',
    difficulty: 'hard',
    verbalType: 'wordConnections'
  },
  {
    id: 'v_wc_h4',
    subject: 'verbal',
    text: 'Complete: Telescope is to distant as microscope is to ?',
    options: ['Lens', 'Small', 'Vision', 'Magnify'],
    correctAnswer: 'Small',
    explanation: 'Telescopes view distant objects, and microscopes view small objects.',
    difficulty: 'hard',
    verbalType: 'wordConnections'
  },
  {
    id: 'v_wc_h5',
    subject: 'verbal',
    text: 'Complete: Democracy is to citizens as monarchy is to ?',
    options: ['Government', 'Kingdom', 'Royalty', 'Politics'],
    correctAnswer: 'Royalty',
    explanation: 'In a democracy, citizens hold power; in a monarchy, royalty holds power.',
    difficulty: 'hard',
    verbalType: 'wordConnections'
  },
  
  // Closest Meaning (5 new hard)
  {
    id: 'v_cm_h1',
    subject: 'verbal',
    text: 'Which word is closest in meaning to "ubiquitous"?',
    options: ['Rare', 'Unique', 'Omnipresent', 'Hidden'],
    correctAnswer: 'Omnipresent',
    explanation: '"Omnipresent" means present everywhere, which is closest to "ubiquitous".',
    difficulty: 'hard',
    verbalType: 'closestMeaning'
  },
  {
    id: 'v_cm_h2',
    subject: 'verbal',
    text: 'Which word is closest in meaning to "egregious"?',
    options: ['Excellent', 'Outrageous', 'Normal', 'Careful'],
    correctAnswer: 'Outrageous',
    explanation: '"Outrageous" means shocking or appalling, which is closest to "egregious".',
    difficulty: 'hard',
    verbalType: 'closestMeaning'
  },
  {
    id: 'v_cm_h3',
    subject: 'verbal',
    text: 'Which word is closest in meaning to "esoteric"?',
    options: ['Popular', 'Common', 'Obscure', 'Simple'],
    correctAnswer: 'Obscure',
    explanation: '"Obscure" means not widely known, which is closest to "esoteric".',
    difficulty: 'hard',
    verbalType: 'closestMeaning'
  },
  {
    id: 'v_cm_h4',
    subject: 'verbal',
    text: 'Which word is closest in meaning to "equivocate"?',
    options: ['Clarify', 'Prevaricate', 'Decide', 'Determine'],
    correctAnswer: 'Prevaricate',
    explanation: '"Prevaricate" means to speak or act evasively, which is closest to "equivocate".',
    difficulty: 'hard',
    verbalType: 'closestMeaning'
  },
  {
    id: 'v_cm_h5',
    subject: 'verbal',
    text: 'Which word is closest in meaning to "ephemeral"?',
    options: ['Eternal', 'Fleeting', 'Substantial', 'Durable'],
    correctAnswer: 'Fleeting',
    explanation: '"Fleeting" means lasting for a very short time, which is closest to "ephemeral".',
    difficulty: 'hard',
    verbalType: 'closestMeaning'
  },

  // Reading Information (5 new hard)
  {
    id: 'v_ri_h1',
    subject: 'verbal',
    text: 'A train leaves station A at 10:00 AM traveling at 60 mph. Another train leaves station B at 11:00 AM traveling at 90 mph toward station A. If the stations are 300 miles apart, at what time will the trains meet?',
    options: ['12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM'],
    correctAnswer: '12:30 PM',
    explanation: 'When the second train starts at 11:00 AM, the first train has already traveled 60 miles (1 hour × 60 mph). Remaining distance: 240 miles. Combined speed: 150 mph. Time to meet: 240 ÷ 150 = 1.6 hours = 1 hour 36 minutes. Meeting time: 11:00 AM + 1:36 = 12:36 PM ≈ 12:30 PM.',
    difficulty: 'hard',
    verbalType: 'readingInfo'
  },
  {
    id: 'v_ri_h2',
    subject: 'verbal',
    text: 'In a class of 30 students, 18 study French, 15 study German, and 5 study both languages. How many students study neither language?',
    options: ['2', '3', '5', '7'],
    correctAnswer: '2',
    explanation: 'Students studying French only: 18 - 5 = 13. Students studying German only: 15 - 5 = 10. Total students studying at least one language: 13 + 10 + 5 = 28. Students studying neither: 30 - 28 = 2.',
    difficulty: 'hard',
    verbalType: 'readingInfo'
  },
  {
    id: 'v_ri_h3',
    subject: 'verbal',
    text: 'John, Kate, and Mike finished a race in different positions. Mike finished after Kate. John finished before Mike. Who came in second place?',
    options: ['John', 'Kate', 'Mike', 'Cannot determine'],
    correctAnswer: 'Mike',
    explanation: 'Since Mike finished after Kate, Kate must be third or second. Since John finished before Mike, John must be first or second. This means Kate can\'t be second, so Mike must be second.',
    difficulty: 'hard',
    verbalType: 'readingInfo'
  },
  {
    id: 'v_ri_h4',
    subject: 'verbal',
    text: 'A grocer buys apples at $0.80 per pound and sells them at $1.20 per pound. If the grocer sells 150 pounds of apples, what is the profit?',
    options: ['$40', '$50', '$60', '$70'],
    correctAnswer: '$60',
    explanation: 'Cost: 150 × $0.80 = $120. Revenue: 150 × $1.20 = $180. Profit: $180 - $120 = $60.',
    difficulty: 'hard',
    verbalType: 'readingInfo'
  },
  {
    id: 'v_ri_h5',
    subject: 'verbal',
    text: 'A pizza shop offers 3 sizes (small, medium, large), 4 types of crusts, and 8 toppings. If a customer can select any size, any type of crust, and any number of toppings (from 0 to all 8), how many different pizza combinations are possible?',
    options: ['96', '256', '768', '1152'],
    correctAnswer: '768',
    explanation: '3 sizes × 4 crusts × 2^8 (256) topping combinations = 3 × 4 × 256 = 3072 combinations.',
    difficulty: 'hard',
    verbalType: 'readingInfo'
  }
];

export default hardVerbalQuestions;
